import {
  ChakraFlex,
  FAIconName,
  Icon,
  Text,
  TextAreaInputV2,
} from '@equip.health/ui';
import { GOAL_DESCRIPTION_MAX_HEIGHT } from '~/lib/constants/carePlan.constants';

type Props = {
  description: string;
  isDescriptionChangedAndVisible: boolean;
  goalId: string;
  idPrefix: string;
  isUpdateGoalLoading: boolean;
  isUpdateGoalSuccess: boolean;
  onBlur: () => void;
  onChange: (next: string) => void;
  onFocus?: () => void;
};

// Description textarea + autosave indicator row, shared by ED and co-occurring note-drawer goal cards.
export const PatientNoteGoalDescriptionPanel = ({
  description,
  isDescriptionChangedAndVisible,
  goalId,
  idPrefix,
  isUpdateGoalLoading,
  isUpdateGoalSuccess,
  onBlur,
  onChange,
  onFocus,
}: Props) => {
  return (
    <ChakraFlex flexDirection="column" gap="4px">
      <TextAreaInputV2
        ariaLabel="Goal description"
        fitContent
        id={`${idPrefix}-${goalId}`}
        maxHeight={GOAL_DESCRIPTION_MAX_HEIGHT}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        placeholder="Add context regarding progress towards this goal (optional)"
        value={description}
      />
      <ChakraFlex
        alignItems="center"
        gap="6px"
        height="20px"
        justifyContent="flex-end"
        width="100%"
      >
        {isUpdateGoalLoading && (
          <Text color="neutral.secondary" marginRight="2px" variant="caption">
            Saving to care plan...
          </Text>
        )}
        {isUpdateGoalSuccess && !isDescriptionChangedAndVisible && (
          <>
            <Icon color="neutral.secondary" name={FAIconName.checkRegular} />
            <Text color="neutral.secondary" marginRight="2px" variant="caption">
              Saved to care plan
            </Text>
          </>
        )}
      </ChakraFlex>
    </ChakraFlex>
  );
};
